import React from 'react';

import { Txt } from '@vst/beam';

import { CheckoutCartProps, DurationPromo } from '../types';
import { formatString } from '../../../utils';

import styles from './priceDetailPromo.module.scss';

type PriceDetailPromoProps = {
  translationKey: CheckoutCartProps['translationKeys']['serviceDetails']['priceAfterPromotion'];
  durationClosingOffer: number;
  promoDuration: DurationPromo;
  totalPrice: string;
  totalPriceWithoutPromotions: string;
  totalPriceWithAddons?: string;
};

const generateDisplayText = ({
  translationKey,
  durationClosingOffer,
  promoDuration = { planPromoDuration: undefined, addonPromoDuration: 0 },
  totalPrice,
  totalPriceWithoutPromotions,
  totalPriceWithAddons,
}: PriceDetailPromoProps) => {
  const { planPromoDuration, addonPromoDuration } = promoDuration;
  if (!planPromoDuration && !addonPromoDuration && !durationClosingOffer) {
    return '';
  }

  const promotions = new Map<number, string>();

  if (durationClosingOffer) {
    promotions.set(
      durationClosingOffer,
      formatString(translationKey?.(`${totalPrice}`, `${durationClosingOffer}`), durationClosingOffer),
    );
  }

  if (promoDuration.planPromoDuration && totalPriceWithoutPromotions) {
    promotions.set(
      promoDuration.planPromoDuration,
      formatString(
        translationKey?.(`${totalPriceWithoutPromotions}`, `${promoDuration.planPromoDuration}`),
        promoDuration.planPromoDuration,
      ),
    );
  }

  if (promoDuration.addonPromoDuration && totalPriceWithAddons) {
    promotions.set(
      promoDuration.addonPromoDuration,
      formatString(
        translationKey?.(`${totalPriceWithAddons}`, `${promoDuration.addonPromoDuration}`),
        promoDuration.addonPromoDuration,
      ),
    );
  }

  return Array.from(promotions.entries())
    .sort((a, b) => a[0] - b[0])
    .map(([, text]) => text)
    .join(', ');
};

const PriceDetailPromo = (props: PriceDetailPromoProps) => {
  const displayText = generateDisplayText(props);

  return (
    <Txt
      variant="tinyItalic"
      color="info"
      className={styles['priceDetailPromo']}
      data-testid="totalMonthlyPlanPriceWithoutPromo"
    >
      {displayText}
    </Txt>
  );
};

export default PriceDetailPromo;
